export const unableConsentReasons = [
  "Patient unconscious",
  "Patient sedated",
  "Cognitive impairment",
  "Severe pain or distress",
  "Emergency situation",
  "Language barrier",
  "Hearing impairment",
  "Developmental disability",
  "Under influence of medication or substances",
];

export const consultantOptions = [
  "Dr. A. Kumar",
  "Dr. R. Sharma",
  "Dr. S. Mehta",
  "Dr. P. Verma",
  "Dr. N. Rao"
];

export const wardBedOptions = [
  "Ward A - Bed 1", "Ward A - Bed 2", "Ward A - Bed 3", "Ward A - Bed 4", "Ward A - Bed 5",
  "Ward B - Bed 1", "Ward B - Bed 2", "Ward B - Bed 3", "Ward B - Bed 4", "Ward B - Bed 5",
  "ICU - Bed 1", "ICU - Bed 2", "ICU - Bed 3", "ICU - Bed 4", "ICU - Bed 5",
  "NICU - Bed 1", "NICU - Bed 2", "NICU - Bed 3",
  "Emergency - Bed 1", "Emergency - Bed 2", "Emergency - Bed 3", "Emergency - Bed 4", "Emergency - Bed 5"
];

export const anaesthesiaOptions = [
  "General anaesthesia with airway management and post-op observation.",
  "Regional block with sedation under continuous monitoring.",
  "Local anaesthesia without sedation for minor procedure.",
  "Combination of regional and general anaesthesia for pain management.",
  "Spinal anaesthesia with close cardiovascular monitoring."
];

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown", "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson", "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark", "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen", "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker", "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner", "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair", "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"
  ]
};

export const signatureDatetimeMap = {
  patient_signature: "patient_signature_date_time",
  witness_signature: "witness_signature_date_time",
  doctor_anaesthetist_signature: "doctor_anaesthetist_signature_date_time",
  interpreter_signature: "interpreter_signature_date_time",
  patient_rep_signature: "patient_rep_signature_date_time",
  patient_rep_witness_signature: "patient_rep_witness_date_time",
  patient_rep_doctor_anaesthetist_sign: "patient_rep_doctor_anaesthetist_sign_date_time",
  patient_rep_interpreter_signature: "patient_rep_interpreter_signature_date_time"
};
